var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pageWithHeaderBody userBackground layout-column" },
    [
      _c(
        "div",
        { class: _vm.$style.container },
        [
          _c(
            "div",
            { class: _vm.$style.navigationContainer },
            [
              _c("profile-photo"),
              _c("div", [
                _c("h1", { class: _vm.$style.pageTitle }, [
                  _vm._v("User Profile"),
                ]),
                _c(
                  "a",
                  {
                    class: _vm.hrefProfile.styles.navItem,
                    attrs: { href: _vm.hrefProfile.href },
                  },
                  [
                    _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        class: _vm.hrefProfile.styles.navIcon,
                      },
                      [_vm._v("account_circle")]
                    ),
                    _c("span", { class: _vm.hrefProfile.styles.navLabel }, [
                      _vm._v("Personal Information"),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c("personal-info", {
            class: _vm.$style.content,
            attrs: { user: _vm.user.data },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }